import { z } from 'zod'

export enum CaseStatusEnum {
  likely_good = 'likely_good',
  caution = 'caution',
  overruling_risk = 'overruling_risk',
  likely_bad = 'likely_bad',
}

export type WarningCaseStatus = Exclude<CaseStatusEnum, CaseStatusEnum.likely_good>
export type CheckedCaseStatus = CaseStatusEnum.likely_good
export type DisplayableCaseStatus = CaseStatusEnum

// Main schema for the entire JSON structure.
export const caseStatusResponseSchema = z.object({
  parent_id: z.string(),
  status: z.string(),
})
export type CaseStatusResponse = z.infer<typeof caseStatusResponseSchema>

export function isWarningCaseStatus(status: string | null | undefined): status is WarningCaseStatus {
  return status === CaseStatusEnum.caution || status === CaseStatusEnum.overruling_risk || status === CaseStatusEnum.likely_bad
}

export function isCheckedCaseStatus(status: string | null | undefined): status is CheckedCaseStatus {
  return status === CaseStatusEnum.likely_good
}

export function isDisplayableCaseStatus(status: string | null | undefined): status is DisplayableCaseStatus {
  return isCheckedCaseStatus(status) || isWarningCaseStatus(status)
}
